import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Loading } from "../../components/ui";
import { t } from "../../i18n/t";
import { formatNumber } from "../../lib/format";
import { kommuneSummaries } from "../../lib/national";
import { routes } from "../../lib/routes";
import { useNational } from "../../lib/useNational";
import { usePageTitle } from "../../lib/usePageTitle";
import { KommuneSearch } from "./KommuneSearch";
import { LoadError } from "./LoadError";

/** `/kommuner`: search and the full alphabetical list of analysed kommuner. */
export function KommunerPage() {
  usePageTitle(t("kommunerPage.title"));
  const national = useNational();
  const list = useMemo(
    () => (national.data ? kommuneSummaries(national.data) : []),
    [national.data],
  );

  return (
    <div className="page narrow">
      <header className="page-header">
        <h1>{t("kommunerPage.title")}</h1>
        <p className="lead">{t("kommunerPage.lead")}</p>
      </header>
      <KommuneSearch showError={false} />
      <h2 className="kommune-list-title">{t("kommunerPage.listTitle")}</h2>
      {national.loading && <Loading />}
      {national.error && (
        <LoadError message={t("kommunerPage.loadFailed")} onRetry={national.reload} />
      )}
      {national.data && (
        <ul className="plain-list kommune-list">
          {list.map((k) => (
            <li key={k.nr}>
              <Link to={routes.kommunePublic(k.nr)}>
                <span className="kommune-list-name">
                  <span className="picker-name">{k.name}</span>
                  <span className="muted small">{k.nr}</span>
                </span>
                <span className="kommune-list-meta">
                  <span>
                    {k.schools === 1
                      ? t("kommunerPage.schoolsOne")
                      : t("kommunerPage.schoolsMany", { n: formatNumber(k.schools) })}
                  </span>
                  {k.counts.red > 0 && (
                    <span className="mini-count mini-red">
                      {t("kommunerPage.redCount", { n: k.counts.red })}
                    </span>
                  )}
                  {k.counts.yellow > 0 && (
                    <span className="mini-count mini-yellow">
                      {t("kommunerPage.yellowCount", { n: k.counts.yellow })}
                    </span>
                  )}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
